import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';
import { RouteLegsService } from '@shared/services';
import type { TRoutesViewModel } from '@shared/models';
// import { TTicket } from '@shared/models';
// The guts of this component is just to manage the reordering of the Tickets
// The reordered tickets is then passed to NavigationHelper to build out the route

@Component({
    'selector': 'app-route4Ordering',
    'templateUrl': './route4Ordering.page.html',
    'styleUrls': ['./route4Ordering.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class Route4OrderingPage extends ViewBasePage implements OnInit, OnDestroy {
    public vm: TRoutesViewModel;
    public subsetRouteLegs = [];

    constructor(private routeLegsService: RouteLegsService,  injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_ROUTE_PAGE4);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.vm = super.getViewModel();

        this.vm.routeLegs = this.routeLegsService.buildRouteLegs(
            this.vm.startingPoint, this.vm.endingPoint, this.vm.selectedTickets);
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public onNextClick() {
        if (!this.vb.disabled) {
            super.setViewModel(this.vm);
            this.router.navigateByUrl('/routes/route5Verification');
        }
    }

    // // Move the ticket from one position to another.
    // public onTicketMove(ev) {
    //     console .log(ev);
    //     const from = ev.detail.from;
    //     const to = ev.detail.to;

    //     this.swapLegPositions(from, to);
    //     const status = this.ensureSeatAvailability();

    //     if (status) {
    //         this.vm.routeLegs = this.navigationHelperService.buildRouteLegs(
    //             this.vm.startingPoint, this.vm.endingPoint, this.vm.selectedTickets);
    //     } else {
    //         const msg = 'This route doesnt allow for enough seats. Resetting to the previous route configuration ';
    //         this.uxHelperService.showAlert('Invalid Route Configuration', msg);
    //         this.swapLegPositions(to, from);
    //     }
    //     ev.detail.complete();
    // }

    // Move the ticket from one position to another.
    public onMoveLeg(ev: any) {
        try {
            const from = ev.detail.from;
            const to = ev.detail.to;
            // const ticket = this.vm.selectedTickets[from];
            // this.vm.selectedTickets.splice(from, 1);
            // this.vm.selectedTickets.splice(to, 0, ticket);
            // console.log('Before complete.  this.vm.selectedTickets:', this.vm.selectedTickets);
            this.vm.selectedTickets = ev.detail.complete(this.vm.selectedTickets);
            // console.log('After  complete.  this.vm.selectedTickets:', this.vm.selectedTickets);

            const seatsAreAvailable = this.ensureSeatAvailability();

            if (seatsAreAvailable) {
                this.vm.routeLegs = this.routeLegsService.buildRouteLegs(
                    this.vm.startingPoint, this.vm.endingPoint, this.vm.selectedTickets);
            } else {
                const msg = 'This ordering doesnt allow for enough seats. Resetting to the previous route ordering.';
                this.uxHelperService.showAlert('Invalid Route Configuration', msg);
                this.swapLegPositions(to, from);
            }
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    // Swap the tickets around and then rebuild the legs.
    private swapLegPositions(fromIndex: number, toIndex: number) {
        const ticket = this.vm.selectedTickets[fromIndex];
        this.vm.selectedTickets.splice(fromIndex, 1);
        this.vm.selectedTickets.splice(toIndex, 0, ticket);

        this.vm.routeLegs = this.routeLegsService.buildRouteLegs(
            this.vm.startingPoint, this.vm.endingPoint, this.vm.selectedTickets);

        // It's important that we keep the selected tickets in sync with each move because
        // in a moment we are calling ensureSeatAvailability() and it references the
        // selected tickets.
        // this.buildTicketArrays();
    }

    private ensureSeatAvailability() {
        let runningTotalSeatAvailability = this.vm.dropoffManifest.seatsAvailable;

        for (let idx = 0; idx < this.vm.selectedTickets.length; idx++) {
            const ticket = this.vm.selectedTickets[idx];

            if (ticket.fromDealership) {
                runningTotalSeatAvailability += ticket.numPassengers;
            } else {
                runningTotalSeatAvailability -= ticket.numPassengers;
            }

            if (runningTotalSeatAvailability < 0) {
                return false;
            }
        }
        return true;
    }
}
